require('./fabricKMeansFilter.js');
require('./fabricMaskedImage.js');
require('./fabricFloodFillFilter.js');
require('./fabricOutlineFilter.js');
require('./fabricShadowFilter.js');
const { 
    constrainPositionToBoundingBox, 
    constrainDimensionToBoundingBox, 
    constrainRotationToBoundingBox 
} = require('../utils/geometryUtils.js');
const { DEFAULT_SHADOW_FILL } = require('../utils/shadowDefaults.js');

fabric.IMAGE_MODE_SINGLE_COLOR = 'single color';
fabric.IMAGE_MODE_FULL_COLOR = 'full color';
fabric.IMAGE_MODE_GRADING = 'grading';
fabric.filterBackend = new fabric.Canvas2dFilterBackend();

fabric.ImagePlaceholder = fabric.util.createClass(fabric.Group, {
    type: 'image-placeholder',

    cacheProperties: fabric.Group.prototype.cacheProperties.concat(
        'imageColor',
        'threshold',
        'imageMode',
        'stroke',
        'enablePerspective',
        'perspectiveCoords'
    ),

    imageMode: fabric.IMAGE_MODE_FULL_COLOR,
    originalElement: null, // Original image element
    lockUniScalingWithSkew: false, // Allows only proportional scaling but also allowing skew operations
    lockMouseMovement: false, // Wether to allow or not to move the images in edit mode through mouse or touch events

    originalMaskElement: null,

    maskingColor: '#000000',
    coverMaskArea: false,
    hasMask: false,
    preventEditMode: false,

    threshold: 150,
    imageColor: '#000000',

    // Drop shadow. null means no shadow; 0 = drop, 1 = blurred drop (ShadowTypeEnum)
    shadowType: null,
    shadowOffset: 0,
    shadowAngle: 0,
    shadowBlur: 0,
    shadowColor: null,
    shadowColorsMap: null,
    shadowColorOption: 1,
    shadowColorLibraryId: null,
    shadowFill: DEFAULT_SHADOW_FILL,

    // (Don't show)/(show) red lines on edit mode
    silentEditMode: false,

    // Private properties
    _emptyImage: false,

    // Mask edit mode related (moving, rotating and scaling image)
    _editMode: false,
    _noMaskScaleX: 1,
    _noMaskScaleY: 1,

    // Image scale needed to fit the container without applying extra mask scaling, used when
    //  no mask is applied
    _noMaskOriginalImgScale: 1,

    _originalStroke: null,
    _originalStrokeWidth: null,
    _originalCanvasSelection: true,
    _originalLockX: false,
    _originalLockY: false,

    _initialMouseX: 0,
    _initialMouseY: 0,

    _forcedEditMode: false,
    rotationStep: 1, // Rotation step in degrees for edit mode

    // Rectangle used to indicate image zoom, rotation and movement within the mask
    _maskBoundsRectangle: null,
    _boundingBoxOffsetX: 0,
    _boundingBoxOffsetY: 0,
    _relationshipMatrix: null,

    removeWhiteBackground: false, // Remove white background from corners
    enableClipPath: true, // Enable a clip path around the element bound so when moving the image it cannot go outside
    isLimitImageToPlaceholder: false,
    lockMovement: false, // Block moving/rotating the image; enforced in edit mode except during Set Initial Position
    lockScaling: false, // Block resizing the image; enforced in edit mode except during Set Initial Position
    textToImage: false, // Open AI Dall-e 3
    CustomilyRemoveBackground: false, // Remove background from image (Customily)
    CustomilyFaceCutOut: false, // Face cut out from image (Customily)
    allowEdit: false, // Allows clients to change the position, size and rotation (only for dynamic images)
    _maskBoundsRectangle_mtr: true,
    pageEpsId: undefined,
    saveImagePosition: false,

    initialize: function (element, optionsOpt, callbackOpt) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        let scope = this;
        const isMobile = !!optionsOpt.isMobile;
        this.enablePerspective = optionsOpt.enablePerspective || false;
        this.perspectiveCoords = optionsOpt.perspectiveCoords || null;

        // Image element, we use a custom image element where we can set the mask image because doing it
        //  in an image filter has HUGE performance penalty because every time the filters pipeline is processed
        //  CanvasRenderingContext2D.getImageData() is called which is very expensive when doing realtime processing
        //  like when we move the mask with the mouse, it's ok for filters that do not change a lot.
        const image = new fabric.MaskedImage(
            element,
            {
                originX: 'center',
                originY: 'center',
                width: optionsOpt.width || 300,
                height: optionsOpt.height || 300,
                filters: []
            },
            callbackOpt
        );

        const boundsRectangle = new fabric.Rect({
            strokeDashArray: optionsOpt.strokeDashArray,
            originX: 'center',
            originY: 'center',
            stroke: optionsOpt.stroke || '#000000',
            strokeWidth: typeof optionsOpt.strokeWidth != 'undefined' ? optionsOpt.strokeWidth : 5,
            width: optionsOpt.width || 300,
            height: optionsOpt.height || 300,
            fill: 'rgba(0, 0, 0, 0)',
            id: optionsOpt.id
        });

        this._maskBoundsRectangle = new fabric.Rect({
            originX: 'center',
            originY: 'center',
            strokeWidth: 3,
            stroke: 'rgba(0, 0, 0, 0)',
            width: optionsOpt.width || 300,
            height: optionsOpt.height || 300,
            fill: 'rgba(0, 0, 0, 0)',
            lockSkewingX: true,
            lockSkewingY: true
        });

        this._maskBoundsRectangle.setControlsVisibility({
            tl: !isMobile,
            tr: !isMobile,
            br: !isMobile,
            bl: !isMobile,
            mtr: !isMobile,

            ml: false,
            mb: false,
            mr: false,
            mt: false,
            mtr: optionsOpt._maskBoundsRectangle_mtr
        });

        this.enableClipPath =
            typeof optionsOpt.enableClipPath !== 'undefined' ? optionsOpt.enableClipPath : this.enableClipPath;
        this.callSuper('initialize', [image, boundsRectangle], optionsOpt);

        //image outline
        this.outlineWidth = optionsOpt.outlineWidth;
        this.outlineColor = optionsOpt.outlineColor;

        //image shadow
        this.loadShadow(optionsOpt);

        this._adjustClippingPath();
        this._resetFakeBoundingBox();
        this.setElement(element);
        this.setMode(this.imageMode);

        // Default fake bounding box values
        this._maskBoundsRectangle._initialMaskOffsetX = 0;
        this._maskBoundsRectangle._initialMaskOffsetY = 0;
        this._maskBoundsRectangle._lastValidAngle = this._maskBoundsRectangle.angle;
        // Events from the bounding box rectangle used in mask edit mode
        this._maskBoundsRectangle.on({
            mousedown: function () {
                // Refresh the rotation baseline at the start of every interaction so a
                // rejected rotation reverts to the current angle.
                this._lastValidAngle = this.angle;
                const block = !scope.saveImagePosition;
                const movementLocked = scope.lockMouseMovement || (scope.lockMovement && block);
                this.lockMovementX = movementLocked;
                this.lockMovementY = movementLocked;
                scope.canvas.fire('object:placeholder:mousedown');
            },
            mouseup: function () {
                scope.canvas.fire('object:placeholder:mouseup');
            },
            selected: function () {
                scope.lastAngle = this.angle;
                scope.canvas.fire('object:placeholder:maskSelected');
            },
            deselected: function (e) {
                scope.fire('deselected', e);
            },
            rotating: function () {
                if (scope._isCoverMode()) {
                    scope._updateMaskAngle(0);
                    return;
                }

                // Rotate the element in steps
                this.angle = Math.ceil(this.angle / scope.rotationStep) * scope.rotationStep;

                // Reject a rotation that would push a contained image outside the bounding box
                if (!scope._resolveRotation(this.width, this.height, this.angle)) {
                    this.angle = this._lastValidAngle != null ? this._lastValidAngle : scope.angle;
                    this.setCoords();
                    return;
                }
                this._lastValidAngle = this.angle;

                scope._updateMaskAngle(this.angle - scope.angle);
                if (scope._shouldContain()) {
                    scope._clampPositionAfterTransform();
                }
                scope._updateRelationshipMatrix();

                if (scope.canvas) {
                    scope.canvas.fire('object:placeholder:maskModified', {
                        object: scope,
                        parameters: scope.getEditModeImageParameters()
                    });
                }
            },
            scaling: function () {
                if(scope.saveImagePosition) {
                    const imgRect = scope._getImageLocalRect();
                    var scaleLimit = constrainDimensionToBoundingBox(scope.item(1), imgRect, imgRect.width, imgRect.height);
                    if (this.scaleX > scaleLimit.scaleX || this.scaleY > scaleLimit.scaleY) {
                        this.scaleX = 1;
                        this.scaleY = 1;
                        return false;
                    }
                }
                const w = this.width * this.scaleX,
                    h = this.height * this.scaleY;

                // Contained image: reject a scale that overflows the bounding box
                if (scope._shouldContain() && !scope._fitsInsideBoundingBox(w, h, this.angle)) {
                    this.scaleX = 1;
                    this.scaleY = 1;
                    this.setCoords();
                    return;
                }
                
                // Set element width and height
                this.set('width', w);
                this.set('height', h);

                this.scaleX = 1;
                this.scaleY = 1;

                const baseline = scope._noMaskOriginalImgScale;
                const scaleX = this.width / (scope.item(0).width * baseline);
                const scaleY = this.height / (scope.item(0).height * baseline);
                scope._updateMaskScale(scaleX, scaleY);
                if (scope._shouldContain()) {
                    scope._clampPositionAfterTransform();
                }
                scope._updateRelationshipMatrix();

                if (scope.canvas) {
                    scope.canvas.fire('object:placeholder:maskModified', {
                        object: scope,
                        parameters: scope.getEditModeImageParameters()
                    });
                }
            },
            moving: function () {
                // Contained image: while dragging, keep the whole image inside the box
                if (scope._shouldContain()) {
                    const clamped = scope._clampMaskBoundsPosition(this.left, this.top);
                    this.left = clamped.left;
                    this.top = clamped.top;
                    this.setCoords();
                }
                // Cover mode: while dragging, keep the image covering the whole box so no
                //  blank gaps appear.
                if (scope._isCoverMode()) {
                    if (scope.enableClipPath) {
                        scope.setCoords();
                        const clamped = scope._clampMaskBoundsPositionCover(this.left, this.top);
                        this.left = clamped.left;
                        this.top = clamped.top;
                        this.setCoords();
                    }
                }

                // Save the offset from this bounding box from the group
                scope._boundingBoxOffsetX = this.left - scope.left;
                scope._boundingBoxOffsetY = this.top - scope.top;

                const distanceX = (this.left - scope.left) / scope.item(0).scaleX;
                const distanceY = (this.top - scope.top) / scope.item(0).scaleY;
                this._lastDistanceX = distanceX;
                this._lastDistanceY = distanceY;
                scope._updateMaskPosition(distanceX, distanceY);
                scope._updateRelationshipMatrix();

                if (scope.canvas) {
                    scope.canvas.fire('object:placeholder:maskModified', {
                        object: scope,
                        parameters: scope.getEditModeImageParameters()
                    });
                }
            },
            scaled: function () {
                scope.saveInitValues();
            },
            moved: function () {
                scope.saveInitValues();
            },
            rotated: function () {
                scope.saveInitValues();
            }
        });

        this.on({
            scaling: function (event) {
                // Only allow proportional scaling but allowing skew
                if (this.lockUniScalingWithSkew) {
                    let scale = 1;
                    if (event.transform.action === 'scaleX') {
                        scale = this.scaleX;
                    } else {
                        scale = this.scaleY;
                    }

                    this.scaleX = scale;
                    this.scaleY = scale;
                }

                this._updateSvgClipPath();
            },
            moving: function () {
                this._updateSvgClipPath();
            },
            scaled: function () {
                // Override the scaling behavior to change the width and height instead of
                //  applying scaling to the object
                this.setScale(this.width, this.height, true);
            },
            added: function () {
                scope = this; //Fix scope when copying elements
                this.cornerSize = 0.025 * this.canvas.width;
                this.transparentCorners = false;
                if (this.onAddedCanvas) this.onAddedCanvas();
            },
            removed: function () {
                this.canvas.remove(this._maskBoundsRectangle);
            },
            'object:dblclick': function (showEditModeStroke = true) {
                if (!this.preventEditMode && (this._forcedEditMode || !this._emptyImage)) {
                    this._editMode = true;
                    this._enablingEditMode = true;

                    // Disable canvas selection
                    this._originalCanvasSelection = this.canvas.selection;
                    this.canvas.selection = false;

                    // Make sure we can't use the controls when the mouse is over even when they are
                    //  not drawn
                    this._controlsVisibilityBackup = JSON.parse(JSON.stringify(this._getControlsVisibility()));
                    this.setControlsVisibility({
                        bl: false,
                        br: false,
                        mb: false,
                        ml: false,
                        mr: false,
                        mt: false,
                        mtr: false,
                        tl: false,
                        tr: false
                    });

                    // Match selection settings
                    this._maskBoundsRectangle.set('cornerSize', this.cornerSize);
                    this._maskBoundsRectangle.set('transparentCorners', this.transparentCorners);
                    this._maskBoundsRectangle.set('centeredScaling', true);
                    this._maskBoundsRectangle.set('centeredRotation', true);
                    this._maskBoundsRectangle.set('skewX', this.skewX);
                    this._maskBoundsRectangle.set('skewY', this.skewY);
                    this._maskBoundsRectangle.set('zIndex', this.zIndex + 1);

                    // Update rectangle position so if the image placeholder was moved the rectangle follows it
                    const offsetX = this.hasMask
                        ? this._maskBoundsRectangle._lastDistanceX * this.item(0).scaleX
                        : this._boundingBoxOffsetX;
                    const offsetY = this.hasMask
                        ? this._maskBoundsRectangle._lastDistanceY * this.item(0).scaleY
                        : this._boundingBoxOffsetY;
                    this._maskBoundsRectangle.set('left', this.left + offsetX);
                    this._maskBoundsRectangle.set('top', this.top + offsetY);
                    this._maskBoundsRectangle.setCoords();

                    // Select the bounding rectangle object
                    this.canvas.add(this._maskBoundsRectangle);
                    this.canvas.setActiveObject(this._maskBoundsRectangle);
                    this._updateMaskBoundsPosition();
                    this._updateRelationshipMatrix();

                    // Block object movement
                    this._originalLockX = this.lockMovementX;
                    this._originalLockY = this.lockMovementY;
                    this.lockMovementX = this.lockMovementY = true;

                    this._initialMouseX = null;
                    this._initialMouseY = null;

                    if (!this.silentEditMode) {
                        // Make the stroke red
                        this._originalStroke = this.item(1).stroke;
                        this._originalStrokeWidth = this.item(1).strokeWidth;                        
                        this.item(1).set('strokeWidth', showEditModeStroke ? 1 : 0);
                        if(showEditModeStroke) {
                            this.item(1).set('stroke', 'red');
                        }
                    }

                    if(scope.hasInitValues()) {
                        scope._fitFakeBoundingBoxToImage();
                    }
                    // Hide the handles for locked operations so they don't look interactive
                    this._applyEditModeLockControls();
                    this._enablingEditMode = false;
                    this.canvas.requestRenderAll();
                }
            },
            deselected: function () {
                // When edit mode was forced (calling enableEditMode()) doesn't disable edit mode
                //  on deselection
                if (this._editMode && !this._forcedEditMode && !this._enablingEditMode) {
                    this._editMode = false;
                    this.canvas.selection = this._originalCanvasSelection;
                    this.canvas.remove(this._maskBoundsRectangle);

                    // Restore controls
                    this.setControlsVisibility(this._controlsVisibilityBackup);

                    // Restore movement lock
                    this.lockMovementX = this._originalLockX;
                    this.lockMovementY = this._originalLockY;

                    if (!this.silentEditMode) {
                        this.item(1).set('stroke', this._originalStroke);
                        this.item(1).set('strokeWidth', this._originalStrokeWidth);
                        this.set('dirty', true);
                    }

                    this._controlsVisibilityBackup = null;
                    this.canvas.renderAll();
                }
                this.saveImagePosition = false;
            },
            rotating: function () {
                this._maskBoundsRectangle.set('angle', this.angle);
                this._updateSvgClipPath();
            },
            rotated: function () {
                this._updateMaskBoundsPosition();
                this._updateRelationshipMatrix();
            }
        });
    },

    /**
     * Sets specified property to a specified value
     * @param {String} key
     * @param {*} value
     * @return {fabric.Text} thisArg
     * @chainable
     */
    _set: function (key, value) {
        if (key === 'id') {
            if (this._maskBoundsRectangle) {
                this._maskBoundsRectangle.id = value;
            }
        } else if (key === 'lockMouseMovement') {
            if (value) {
                this._maskBoundsRectangle.lockMovementX = true;
                this._maskBoundsRectangle.lockMovementY = true;
            } else {
                this._maskBoundsRectangle.lockMovementX = false;
                this._maskBoundsRectangle.lockMovementY = false;
            }
        } else if (key === 'imageColor') {
            if (this.item(0).filters[0] && this.item(0).filters[0].type === 'KMeans') {
                this.item(0).filters[0].setFgColor(value);
                this.item(0).applyFilters();
            }
        } else if (key === 'imageOutlineColor' || key === 'imageOutlineWidth') {
            if (key === 'imageOutlineColor') {
                this.outlineColor = value;
            } else {
                this.outlineWidth = value;
            }
            const outlineFilterElementIndex = (this.item(0).filters || []).findIndex(
                (f) => f && f.type && f.type == 'OutlineFilter'
            );
            if (this.outlineWidth > 0) {
                const imageIutlineColorFilter = new fabric.Image.filters.OutlineFilter({
                    outlineColor: this.outlineColor,
                    outlineWidth: this.outlineWidth
                });
                if (outlineFilterElementIndex == -1) {
                    this.item(0).filters.push(imageIutlineColorFilter);
                } else {
                    this.item(0).filters[outlineFilterElementIndex] = imageIutlineColorFilter;
                }
                this.item(0).applyFilters();
            } else if (outlineFilterElementIndex > -1) {
                this.item(0).filters =
                    (this.item(0).filters || []).filter((f) => f && f.type && f.type != 'OutlineFilter') || [];
                this.item(0).applyFilters();
            }

            // The shadow must always be the LAST filter so it's cast by the already outlined
            //  silhouette. Re-adding it puts it back at the end of the pipeline.
            if (this.shadowType != null) {
                this._applyShadowFilter();
            }
        } else if (key === 'width' || key === 'height') {
            // Set the new value before adjusting the image
            this.callSuper('_set', key, value);
            if (this.item(1)) {
                this.item(1).set(key, value);
            }

            this._adjustImage();
            this._adjustClippingPath();
            if(!this.hasInitValues()) {
                this._resetFakeBoundingBox();
            }
            this.setMask(this.originalMaskElement);
        } else if (key === 'rotationStep') {
            if (typeof value === 'undefined') {
                value = this.rotationStep;
            } else if (value < 0 || value == 0) {
                value = 1;
            }
        } else if (key === 'evented') {
            this._maskBoundsRectangle.set('evented', value);

            // If on edit mode, don't alter the evented attribute from the ImagePlaceholder, only from the
            //  selection rectangle
            if (this._forcedEditMode || this._editMode) {
                return;
            }
        } else if (key === 'imageMode') {
            this.callSuper('_set', key, value);
            if (this.originalElement) {
                this.setMode(this.imageMode);
            }
        } else if (key === 'stroke' || key === 'strokeWidth') {
            this.item(1).set(key, value);
        } else if (key === 'angle') {
            this._updateMaskBoundsPosition();
        } else if (key === 'hasControls') {
            this._maskBoundsRectangle.set('hasControls', value);
        } else if (key === 'enableClipPath') {
            this.callSuper('_set', key, value);
            this._adjustClippingPath();
        } else if (key === 'coverMaskArea' || key === 'isLimitImageToPlaceholder') {
            const isModeChange = this[key] !== value;
            this.callSuper('_set', key, value);
            if (isModeChange && this.originalElement) {
                if (this.hasInitValues()) {
                    this.resetInitPosition();
                } else {
                    this.resetImagePositionAndSize();
                }
            }
            return;
        } else if (key === 'lockScaling' || key === 'lockMovement') {
            this.callSuper('_set', key, value);
            // Toggling a lock while editing the mask should update the visible handles live
            if (this._editMode) {
                this._applyEditModeLockControls();
            }
            return;
        }

        this.callSuper('_set', key, value);
    },

    /**
     * Rebuilds the drop shadow filter from the current shadow* properties.
     * Always drops the previous instance and pushes the new one at the end of the pipeline: the
     *  shadow has to be the last filter so it's cast by the final silhouette (color mode filters
     *  are unshifted to the front by setMode(), the outline sits in between).
     */
    _applyShadowFilter: function () {
        const imageObj = this.item(0);
        if (!imageObj) {
            return;
        }

        const currentFilters = imageObj.filters || [];
        const currentIndex = currentFilters.findIndex((f) => f && f.type === 'ShadowFilter');
        const current = currentIndex > -1 ? currentFilters[currentIndex] : null;

        // Only re-filter when something actually changed: this runs on every selection of the
        //  placeholder, and re-filtering the whole bitmap each time made dragging it feel stuck.
        //  Position counts as state too: if another filter ended up after this one, rebuild so
        //  the shadow goes back to being last.
        if (
            current &&
            currentIndex === currentFilters.length - 1 &&
            current.shadowType === this.shadowType &&
            current.shadowOffset === this.shadowOffset &&
            current.shadowAngle === this.shadowAngle &&
            current.shadowBlur === this.shadowBlur &&
            current.shadowColor === this.shadowFill
        ) {
            return;
        }

        const filters = currentFilters.filter((f) => !f || f.type !== 'ShadowFilter');
        const hadShadow = currentIndex > -1;

        if (this.shadowType == null) {
            // Nothing to draw and nothing to remove, don't pay for a filter pass
            if (!hadShadow) {
                return;
            }
            imageObj.filters = filters;
        } else {
            filters.push(
                new fabric.Image.filters.ShadowFilter({
                    shadowType: this.shadowType,
                    shadowOffset: this.shadowOffset,
                    shadowAngle: this.shadowAngle,
                    shadowBlur: this.shadowBlur,
                    shadowColor: this.shadowFill
                })
            );
            imageObj.filters = filters;
        }

        // fromObject builds the placeholder before the bitmap is downloaded (new fabric.ImagePlaceholder(null, object)),
        //  and fabric's applyFilters() reads naturalWidth straight off the source element. Leave the pipeline
        //  configured and let setElement() run it: fabric re-applies every filter as soon as the image is set.
        if (imageObj._originalElement) {
            imageObj.applyFilters();
        }
        this.set('dirty', true);
    },

    resetInitPosition: function() {
        this.initCenterX = null;
        this.initCenterY = null;
        this.initWidth = null;
        this.initHeight = null;
        this.initRotation = null;

        this.resetImagePositionAndSize();
        this.setEditedProp?.('initImagePosition');
    },

    resetImagePositionAndSize: function () {
        this._adjustImage();
        this._adjustClippingPath();
        this._resetFakeBoundingBox();
        this._updateRelationshipMatrix();
        this.setMask(this.originalMaskElement);
    },

    /**
     * This method is intended to be called after the object was modified with a group
     *  selection. On fabric.js, elements events are not fired when inside a group, that's
     *  why this method must be called manually after exiting group selection
     */
    updateFromGroupScaling: function () {
        this.setScale(this.width, this.height, false);
    },

    /**
     * This enables edit mode to allow moving and zooming the image with
     *  the mask. This is only enabled if there's a valid mask already applied.
     * The only way to disable edit mode after using enableEditMode() is calling
     *  disableEditMode()
     *  @param {boolean} showEditModeStroke - If false, the mask bounds rectangle will not have a stroke
     */
    enableEditMode: function (showEditModeStroke = true) {
        this._forcedEditMode = true;
        this.fire('object:dblclick', showEditModeStroke);
    },

    disableEditMode: function () {
        this.fire('deselected');
    },

    /**
     * Hide the edit-mode handles for operations that are currently locked, so the mask
     *  bounds rectangle doesn't look interactive when it isn't:
     *   - lockScaling hides the scaling corners (tl/tr/br/bl)
     *   - lockMovement hides the rotation handle (mtr)
     * The locks are bypassed during "Set Initial Position" (saveImagePosition), so in that
     *  mode the handles are restored to their base visibility.
     */
    _applyEditModeLockControls: function () {
        const rect = this._maskBoundsRectangle;
        if (!rect) {
            return;
        }
        // Capture the default control visibility the first time a lock needs to act, before any
        //  lock alters it. The helper is the only thing that changes the rectangle's control
        //  visibility after initialize, so this snapshot is always the clean default. Shallow copy
        //  (not JSON) so keys whose value is undefined (e.g. mtr) are preserved.
        if (!this._maskBoundsRectangleControlsBackup) {
            this._maskBoundsRectangleControlsBackup = { ...rect._getControlsVisibility() };
        }

        const backup = this._maskBoundsRectangleControlsBackup;
        const hideScale = this.lockScaling && !this.saveImagePosition;
        const hideRotate = this.lockMovement && !this.saveImagePosition;
        rect.setControlsVisibility({
            tl: hideScale ? false : backup.tl,
            tr: hideScale ? false : backup.tr,
            br: hideScale ? false : backup.br,
            bl: hideScale ? false : backup.bl,
            mtr: hideRotate ? false : backup.mtr,
            ml: backup.ml,
            mb: backup.mb,
            mr: backup.mr,
            mt: backup.mt
        });
        if (rect.canvas) {
            rect.canvas.requestRenderAll();
        }
    },

    /**
     * Set the image scaling in edit mode. This method will only work if edit mode is enabled!
     * This has the same behavior as scaling the image through the controls.
     */
    setEditModeImageScale: function (scale) {
        if (this._isCoverMode()) {
            const baseSize = this._getInitialBoundsRectangleSize();
            const newW = baseSize.width * scale;
            const newH = baseSize.height * scale;
            const shrinking =
                newW < this._maskBoundsRectangle.width || newH < this._maskBoundsRectangle.height;
            if (shrinking && !this._coversBoundingBox(newW, newH, this._maskBoundsRectangle.angle)) {
                return;
            }
        }

        if (!this._editMode) {
            return;
        }
        if (this._shouldContain()) {
            const baseSize = this._getInitialBoundsRectangleSize();
            const newW = baseSize.width * scale;
            const newH = baseSize.height * scale;
            if (!this._fitsInsideBoundingBox(newW, newH, this._maskBoundsRectangle.angle)) {
                return;
            }
        }
        this._updateMaskScale(scale, scale);
        if (this._shouldContain()) {
            this._clampPositionAfterTransform();
        }
    },

    /**
     * Set the image rotation in edit mode. This method will only work if edit mode is enabled!
     * This has the same behavior as rotating the image through the controls but without angle steps.
     */
    setEditModeImageRotation: function (angle) {
        if (this._isCoverMode()) {
            this._updateMaskAngle(0);
            return;
        }

        if (!this._editMode) {
            return;
        }
        const rect = this._maskBoundsRectangle;
        if (!this._resolveRotation(rect.width, rect.height, angle + this.angle)) {
            return;
        }
        this._updateMaskAngle(angle);
        if (this._shouldContain()) {
            this._clampPositionAfterTransform();
        }
    },

    /**
     * Set the image offset in edit mode. This method will only work if edit mode is enabled!
     * This has the same behavior as moving the image through the controls.
     */
    setEditModeImageOffset: function (x, y) {
        if (!this._editMode) {
            return;
        }
        if (this._shouldContain()) {
            const imgScaleX = this.item(0).scaleX || 1;
            const imgScaleY = this.item(0).scaleY || 1;
            const proposedLeft = this.left + x * imgScaleX;
            const proposedTop = this.top + y * imgScaleY;
            const clamped = this._clampMaskBoundsPosition(proposedLeft, proposedTop);
            x = (clamped.left - this.left) / imgScaleX;
            y = (clamped.top - this.top) / imgScaleY;
        }
        this._updateMaskPosition(x, y);
    },

    // Obtain the rotation, scaling and offset of the image in edit mode
    getEditModeImageParameters: function () {
        if (!this.hasMask) {
            return {
                offsetX: this._maskBoundsRectangle._lastDistanceX || 0,
                offsetY: this._maskBoundsRectangle._lastDistanceY || 0,
                scaleX: this._noMaskScaleX || 1,
                scaleY: this._noMaskScaleY || 1,
                angle: this.item(0).angle || 0,
                threshold: this.threshold
            };
        } else {
            return {
                offsetX: this._maskBoundsRectangle._lastDistanceX || 0,
                offsetY: this._maskBoundsRectangle._lastDistanceY || 0,
                scaleX: this.item(0).maskScaleX || 1,
                scaleY: this.item(0).maskScaleY || 1,
                angle: this.item(0).maskAngle || 0,
                threshold: this.threshold
            };
        }
    },

    /**
     * Writes a shadow patch in one pass: every property lands before the filter is rebuilt, so
     *  turning a shadow on with its offset, angle, blur and color costs a single filter pass over
     *  the bitmap instead of one per property. Only the keys present in the patch are touched.
     *
     * This is the only way the shadow is edited from the outside (see the ShadowElement contract
     *  the shadow panel is written against), so no caller can accidentally pay for the extra passes.
     */
    applyShadow: function (patch) {
        if (!patch) {
            return;
        }

        // The type is written last on purpose: while it is still null the filter has nothing to
        //  draw, so turning a shadow on rebuilds it exactly once, already complete.
        if ('shadowOffset' in patch) {
            this.shadowOffset = patch.shadowOffset || 0;
        }
        if ('shadowAngle' in patch) {
            this.shadowAngle = patch.shadowAngle || 0;
        }
        if ('shadowBlur' in patch) {
            this.shadowBlur = patch.shadowBlur || 0;
        }
        if ('shadowFill' in patch) {
            this.shadowFill = patch.shadowFill || DEFAULT_SHADOW_FILL;
        }
        if ('shadowType' in patch) {
            this.shadowType = patch.shadowType ?? null;
        }

        this._applyShadowFilter();
    },

    /**
     * Restores a saved shadow. Expects values already parsed by the caller (a real Map, a color
     *  object), same contract the BoundedText constructor has. Call setShadowColor() afterwards to
     *  set the css it paints with.
     */
    loadShadow: function (properties) {
        const source = properties || {};

        // Arrives as a Map from the loaders and as an array of entries when the element was
        //  copied on the canvas (see toObject); the Map constructor takes either.
        this.shadowColorsMap = new Map(source.shadowColorsMap || []);
        this.shadowColorOption = source.shadowColorOption || 1;
        this.shadowColorLibraryId = source.shadowColorLibraryId || null;
        this.shadowColor = source.shadowColor || null;

        this.applyShadow({
            shadowType: source.shadowType,
            shadowOffset: source.shadowOffset,
            shadowAngle: source.shadowAngle,
            shadowBlur: source.shadowBlur
        });
    },

    /**
     * The css the shadow is painted with. Kept apart from shadowColor, which holds the color
     *  option that gets saved: the same option resolves to a different css once alpha or a
     *  library option comes into play.
     */
    setShadowColor: function (color) {
        this.applyShadow({ shadowFill: color });
    },

    getShadowColor: function () {
        return this.shadowFill || DEFAULT_SHADOW_FILL;
    },

    setOpacity: function (opacity) {
        this.item(0).set('opacity', opacity);
    },

    getOpacity: function () {
        return this.item(0).opacity;
    },

    getWidth: function () {
        return this.width * this.scaleX;
    },

    setWidth: function (width, keepRatio = false) {
        if (!width) width = 0;

        if(this.hasInitValues()) {
            let scale = width / this.width;     
            if(keepRatio) {
                /* If keepRatio is true, it means only one side of the bounding box was scaled, 
                but the image must keep its aspect ratio, so we scale both axes.
                However, this can cause the image to go outside the bounding box, 
                so we check that the scale does not exceed the maximum scale of the other axis we are going to scale.*/
                const imgRect = this._getImageLocalRect();
                var scaleLimit = constrainDimensionToBoundingBox(this.item(1), imgRect, imgRect.width, imgRect.height);
                if(scale > scaleLimit.scaleY) {
                    scale = scaleLimit.scaleY;
                }
            }
            this.initWidth = this.initWidth * scale;
            this.initCenterX = this.initCenterX * scale;
            if(keepRatio) {
                this.initHeight = this.initHeight * scale;
            }
            this.setEditedProp?.('initImagePosition');
        }

        this.item(1).set('width', width);
        this.set('width', width);
    },

    getHeight: function () {
        return this.height * this.scaleY;
    },

    setHeight: function (height, keepRatio = false) {
        if (!height) height = 0;

        if(this.hasInitValues()) {
            let scale = height / this.height;
            if(keepRatio) {
                /* If keepRatio is true, it means only one side of the bounding box was scaled, 
                but the image must keep its aspect ratio, so we scale both axes.
                However, this can cause the image to go outside the bounding box, 
                so we check that the scale does not exceed the maximum scale of the other axis we are going to scale.*/
                const imgRect = this._getImageLocalRect();
                var scaleLimit = constrainDimensionToBoundingBox(this.item(1), imgRect, imgRect.width, imgRect.height);
                if(scale > scaleLimit.scaleX) {
                    scale = scaleLimit.scaleX;
                }
            }
            this.initHeight = this.initHeight * scale;
            this.initCenterY = this.initCenterY * scale;
            if(keepRatio) {      
                this.initWidth = this.initWidth * scale;
            }
            this.setEditedProp?.('initImagePosition');
        }
        this.item(1).set('height', height);
        this.set('height', height);
    },

    setScale: function (width, height, updateReferences) {
        const keepRatio = this.hasInitValues() && (this.scaleX == 1 || this.scaleY == 1);
        const w = width * this.scaleX;
        const h = height * this.scaleY;

        if (updateReferences) {
            // Reset bounding box size and offsets        
            if(!this.hasInitValues()) {
                this._resetFakeBoundingBox();
            }
        }

        // Set the new width and height
        this.scaleX = 1;
        this.scaleY = 1;
        this.setWidth(w, keepRatio);
        this.setHeight(h, keepRatio);

        if (updateReferences) {
            this._updateRelationshipMatrix();
        }
    },

    getColor: function () {
        return this.imageColor;
    },

    _getInitialBoundsRectangleSize: function () {
        let width = 0,
            height = 0;
        if (this.originalElement && this.originalElement.width > 0 && this.originalElement.width > 0) {
            const scale = this._computeImageScaling();
            width = this.item(0).width * scale;
            height = this.item(0).height * scale;
        }

        return {
            width: width,
            height: height
        };
    },

    _resetFakeBoundingBox: function () {
        this._boundingBoxOffsetX = this._boundingBoxOffsetY = 0;
        this._maskBoundsRectangle._lastDistanceX = this._maskBoundsRectangle._lastDistanceY = 0;
        this._noMaskScaleX = this._noMaskScaleY = 1;

        const boundSize = this._getInitialBoundsRectangleSize();
        const svgScaleX = this.originalMaskSvg ? this.item(0).scaleX || 1 : 1;
        const svgScaleY = this.originalMaskSvg ? this.item(0).scaleY || 1 : 1;
        this._maskBoundsRectangle.set('width', boundSize.width * svgScaleX);
        this._maskBoundsRectangle.set('height', boundSize.height * svgScaleY);
        this._maskBoundsRectangle.set('angle', this.angle);
        this._maskBoundsRectangle.set('left', this.left);
        this._maskBoundsRectangle.set('top', this.top);
        this._maskBoundsRectangle.setCoords();

        this.item(0).set('left', 0);
        this.item(0).set('top', 0);
        this.item(0).set('angle', 0);

        this.__resetPerspectiveImageSize && this.__resetPerspectiveImageSize();
    },

    /**
     * Returns the visible geometry of the image inside the placeholder, in placeholder-local
     *  units (the same units as item(0).left and this.width).
     * The image transform lives in one of two channels depending on the mask, so every read
     *  of "where the image actually is" has to go through here (same split that
     *  getEditModeImageParameters() already does):
     *   - no mask:     item(0).left/top/angle, zoom folded into item(0).scaleX by _adjustImage()
     *   - raster mask: item(0).maskOffsetX/Y, maskAngle, maskScaleX/Y (item(0).scaleX stays at
     *                   the base fit scale)
     *   - svg mask:    item(0).maskOffsetX/Y and maskAngle, but _updateMaskScale already folded
     *                   the zoom into item(0).scaleX, so maskScaleX must not be counted twice
     */
    _getImageDisplayTransform: function () {
        const img = this.item(0);
        const isRasterMask = this.hasMask && !this.originalMaskSvg;
        const zoomX = isRasterMask ? img.maskScaleX || 1 : 1;
        const zoomY = isRasterMask ? img.maskScaleY || 1 : 1;

        return {
            width: img.width * img.scaleX * zoomX,
            height: img.height * img.scaleY * zoomY,
            // The mask offset is applied by _render inside a context already scaled by
            //  item(0).scaleX, so scaling it here brings it back to placeholder-local units
            centerX: this.hasMask ? (img.maskOffsetX || 0) * img.scaleX : img.left,
            centerY: this.hasMask ? (img.maskOffsetY || 0) * img.scaleY : img.top,
            angle: this.hasMask ? img.maskAngle || 0 : img.angle
        };
    },

    /**
     * The image as a plain rectangle in the group's local space, ready to be passed to the
     *  geometryUtils helpers (they expect {left, top, width, height, angle} with left/top
     *  being the center).
     */
    _getImageLocalRect: function () {
        const t = this._getImageDisplayTransform();
        return {
            left: t.centerX,
            top: t.centerY,
            angle: t.angle,
            width: t.width,
            height: t.height
        };
    },

    _fitFakeBoundingBoxToImage: function () {
        //update fake bounding box to fit with image size and position
        const t = this._getImageDisplayTransform();
        this._maskBoundsRectangle.set('width', t.width);
        this._maskBoundsRectangle.set('height', t.height);

        const absoluteAngle = this.angle + t.angle;
        this._maskBoundsRectangle.set('angle', absoluteAngle);

        const centerPoint = new fabric.Point(t.centerX, t.centerY);
        const absolutePoint = fabric.util.transformPoint(centerPoint, this.calcTransformMatrix());
        this._maskBoundsRectangle.set('left', absolutePoint.x);
        this._maskBoundsRectangle.set('top', absolutePoint.y);

        this._maskBoundsRectangle.setCoords();
    },

    saveInitValues: function() {
        if(!this.saveImagePosition) {
            return;
        }
        const t = this._getImageDisplayTransform();
        this.initWidth = t.width;
        this.initHeight = t.height;
        this.initCenterX = t.centerX;
        this.initCenterY = t.centerY;
        this.initRotation = t.angle;
        this.setEditedProp?.('initImagePosition');
    },

    setElement: function (element) {
        if (!element) {
            element = new Image();
            element.width = element.height = 1;
            this._emptyImage = true;
        } else {
            this._emptyImage = false;
        }

        // Set the new image and adjust it
        this.originalElement = element;
        this.item(0).setElement(element);
        this.setMask(this.originalMaskElement);

        // Re-render elements in the group
        this.set('dirty', true);
    },

    setMask: function (maskElement) {
        const imgElement = this.item(0);

        if (maskElement || !this.originalMaskSvg) {
            this.originalMaskElement = maskElement;

            if (!maskElement) {
                this.hasMask = false;
                imgElement.set('maskElement', null);
            } else {
                this.hasMask = true;

                if (this.originalElement) {
                    // Calculate mask size
                    let maskWidth, maskHeight;
                    if (this.originalElement.width > this.originalElement.height) {
                        maskWidth = this.originalElement.width;
                        maskHeight = (this.getHeight() * this.originalElement.width) / this.getWidth();

                        if (maskHeight < this.originalElement.height) {
                            maskHeight = this.originalElement.height;
                            maskWidth = (this.getWidth() * this.originalElement.height) / this.getHeight();
                        }
                    } else {
                        maskHeight = this.originalElement.height;
                        maskWidth = (this.getWidth() * this.originalElement.height) / this.getHeight();

                        if (maskWidth < this.originalElement.width) {
                            maskWidth = this.originalElement.width;
                            maskHeight = (this.getHeight() * this.originalElement.width) / this.getWidth();
                        }
                    }

                    imgElement.set('maskElement', maskElement);
                    imgElement.set('maskScaleX', 1);
                    imgElement.set('maskScaleY', 1);
                    imgElement.set('maskOffsetX', 0);
                    imgElement.set('maskOffsetY', 0);
                    imgElement.set('maskAngle', 0);
                    imgElement.set('maskHeight', maskHeight);
                    imgElement.set('maskWidth', maskWidth);
                }
            }
        }

        // Reset image size and mask bounding box when adding/removing a mask
        this._adjustImage(true);
        this._resetFakeBoundingBox();
        this._updateRelationshipMatrix();

        if (this.hasInitValues()) {
            this.setOffSetsBasedOnInitValues();
        }

        // If cover mask area is enabled make the image bigger to cover as much as possible on the image placeholder
        //  without distorting it
        if (this.coverMaskArea) {
            let scale = 1;
            if (this.hasMask) {
                const scaleX = this.width / (this.item(0).width * this.item(0).scaleX);
                const scaleY = this.height / (this.item(0).height * this.item(0).scaleY);
                scale = Math.max(scaleX, scaleY);
            } else {
                const scaleX = this.width / (this.item(0).width * this.item(0).scaleX);
                const scaleY = this.height / (this.item(0).height * this.item(0).scaleY);
                scale = Math.max(scaleX, scaleY);
            }

            this._updateMaskScale(scale, scale);
        }
    },

    setOffSetsBasedOnInitValues: function () {
        const editModeOriginalValue = this._editMode;
        this._editMode = true;
        //scale
        const newImageScale = this._computeImageScaling(true);
        const newImageWidth = this.item(0).width * newImageScale;
        const scaleX = newImageWidth / (this.item(0).width * this._noMaskOriginalImgScale);
        this.setEditModeImageScale(scaleX);

        //position
        const point = new fabric.Point(this.initCenterX, this.initCenterY);
        const absolutePoint = fabric.util.transformPoint(point, this.calcTransformMatrix());

        const distanceX = (absolutePoint.x - this.left) / this.item(0).scaleX;
        const distanceY = (absolutePoint.y - this.top) / this.item(0).scaleY;
        this.setEditModeImageOffset(distanceX, distanceY);

        //angle
        this.setEditModeImageRotation(this.initRotation);
        this._editMode = editModeOriginalValue;
    },

    // Edit mode's fixed 1-unit stroke goes sub-pixel on zoomed-out canvases; 'deselected' restores the original
    _applyInitialPositionStroke: function () {
        if (!this._editMode || this.silentEditMode || !this.canvas?.getVisibleStrokeWidth) {
            return;
        }
        this.item(1).set('strokeWidth', this.canvas.getVisibleStrokeWidth() * 6);
        this.item(1).set('stroke', 'red');
        this.set('dirty', true);
        this.canvas.requestRenderAll();
    },

    hasInitValues: function(){
        return this.initCenterX != null &&
            this.initCenterY != null &&
            this.initWidth != null &&
            this.initHeight != null &&
            this.initRotation != null;
    },

    _updateRelationshipMatrix: function () {
        const rectangle = this._maskBoundsRectangle;
        const bossTransform = this.calcTransformMatrix();
        const invertedBossTransform = fabric.util.invertTransform(bossTransform);
        this._relationshipMatrix = fabric.util.multiplyTransformMatrices(
            invertedBossTransform,
            rectangle.calcTransformMatrix()
        );
    },

    _updateMaskBoundsPosition: function () {
        if (this._relationshipMatrix) {
            const relationship = this._relationshipMatrix;
            const newTransform = fabric.util.multiplyTransformMatrices(this.calcTransformMatrix(), relationship);
            const opt = fabric.util.qrDecompose(newTransform);

            this._maskBoundsRectangle.set({
                flipX: false,
                flipY: false
            });

            this._maskBoundsRectangle.setPositionByOrigin(
                {
                    x: opt.translateX,
                    y: opt.translateY
                },
                'center',
                'center'
            );
            this._maskBoundsRectangle.set(opt);
            this._maskBoundsRectangle.setCoords();
        }
    },

    _correctOffset: function (offsetX, offsetY) {
        // Convert canvas coordinate to group relative coordinates
        const mGroup = this.calcTransformMatrix(true);
        const mCanvasObject = fabric.iMatrix;
        const mTotal = fabric.util.multiplyTransformMatrices(mGroup, mCanvasObject);
        const mInverse = fabric.util.invertTransform(mTotal);
        const result = fabric.util.transformPoint(new fabric.Point(this.left + offsetX, this.top + offsetY), mInverse);
        return result;
    },

    _inverseCorrectOffset: function (left, top) {
        const mGroup = this.calcTransformMatrix(true);
        const mCanvasObject = fabric.iMatrix;
        const mTotal = fabric.util.multiplyTransformMatrices(mGroup, mCanvasObject);
        const result = fabric.util.transformPoint(new fabric.Point(left, top), mTotal);

        return {
            x: result.x - this.left,
            y: result.y - this.top
        };
    },

    // Returns the 4 corners of the image as they sit inside the placeholder, ignoring
    //  any rotation/skew/scale applied to the placeholder itself. The result describes
    //  the image as a plain rectangle (size rectW × rectH) rotated only by its own
    //  local angle, around its center.
    //  This is the geometry used by the bounding-box checks below — it lets us reason
    //  about whether the image fits or overflows without worrying about how the
    //  placeholder is transformed on the canvas.
    _getRectCornersInPlaceholderLocalSpace: function (rectW, rectH, rectAngleAbsolute, rectLeft, rectTop) {
        const invIPMatrix = fabric.util.invertTransform(this.calcTransformMatrix());
        const localCenter = fabric.util.transformPoint(
            new fabric.Point(rectLeft || 0, rectTop || 0),
            invIPMatrix
        );
        const localAngle = (rectAngleAbsolute || 0) - (this.angle || 0);
        const rad = fabric.util.degreesToRadians(localAngle);
        const cos = Math.cos(rad);
        const sin = Math.sin(rad);
        const halfW = (rectW || 0) / 2;
        const halfH = (rectH || 0) / 2;
        const rotate = (x, y) => new fabric.Point(
            localCenter.x + x * cos - y * sin,
            localCenter.y + x * sin + y * cos
        );
        return [
            rotate(-halfW, -halfH),
            rotate(halfW, -halfH),
            rotate(halfW, halfH),
            rotate(-halfW, halfH),
        ];
    },
    // cover   (limit + fill)   -> the image can never be SMALLER than the image placeholder bounding box
    // ,so no blank gaps ever show. Rotation stays locked because the cover
    // scale is angle-agnostic.
    _isCoverMode: function () {
        return !!this.isLimitImageToPlaceholder && !!this.coverMaskArea;
    },

    // the image can never be LARGER than the box, so it can 
    //  never overflow. Moving, scaling and rotating stay 
    // available and blank space is allowed.
    _isContainMode: function () {
        return !!this.isLimitImageToPlaceholder && !this.coverMaskArea;
    },

    _shouldContain: function () {
        return !!this.limitMovement || this._isContainMode();
    },

    //Decides whether the image may be rotated so it ends up at `rectAngleAbsolute`.
    //A rotation that would push a contained image outside its bounds is rejected.
    _resolveRotation: function (rectW, rectH, rectAngleAbsolute) {
        if (!this._shouldContain()) {
            return true;
        }
        return this._fitsInsideBoundingBox(rectW, rectH, rectAngleAbsolute);
    },

    // Returns true if a rectangle of the given size and rotation could fit inside
    //  the placeholder's bounding box at all. Used to reject scale or rotation
    //  changes that would make the image overflow its container.
    _fitsInsideBoundingBox: function (rectW, rectH, rectAngleAbsolute) {
        const rect = this._maskBoundsRectangle;
        if (!rect) return true;
        const corners = this._getRectCornersInPlaceholderLocalSpace(
            rectW, rectH, rectAngleAbsolute, rect.left, rect.top
        );
        const xs = corners.map(p => p.x);
        const ys = corners.map(p => p.y);
        const aabbW = Math.max.apply(null, xs) - Math.min.apply(null, xs);
        const aabbH = Math.max.apply(null, ys) - Math.min.apply(null, ys);
        // If the placeholder transform is degenerate (e.g. scale 0), fall back to
        //  the permissive legacy behavior rather than rejecting the operation.
        if (!isFinite(aabbW) || !isFinite(aabbH)) return true;
        return aabbW <= this.width && aabbH <= this.height;
    },

    // Mirror of _fitsInsideBoundingBox for cover mode: returns true if a rectangle of the given
    //  size and rotation is still big enough to cover the whole placeholder, so no blank gaps
    //  can show. Used to reject a zoom-out that would shrink the image below covering size.
    _coversBoundingBox: function (rectW, rectH, rectAngleAbsolute) {
        const rect = this._maskBoundsRectangle;
        if (!rect) return true;
        const corners = this._getRectCornersInPlaceholderLocalSpace(
            rectW, rectH, rectAngleAbsolute, rect.left, rect.top
        );
        const xs = corners.map(p => p.x);
        const ys = corners.map(p => p.y);
        const aabbW = Math.max.apply(null, xs) - Math.min.apply(null, xs);
        const aabbH = Math.max.apply(null, ys) - Math.min.apply(null, ys);
        // If the placeholder transform is degenerate (e.g. scale 0), fall back to
        //  the permissive legacy behavior rather than rejecting the operation.
        if (!isFinite(aabbW) || !isFinite(aabbH)) return true;
        return aabbW >= this.width && aabbH >= this.height;
    },

    // After the user scales or rotates the image in edit mode, ensures the image stays
    //  within the placeholder's bounds. If the transform pushed the image outside, this
    //  snaps it back to the nearest valid position. Does nothing if already within bounds.
    _clampPositionAfterTransform: function () {
        const rect = this._maskBoundsRectangle;
        const img = this.item(0);
        if (!rect || !img) return;
        const clamped = this._clampMaskBoundsPosition(rect.left, rect.top);
        if (clamped.left === rect.left && clamped.top === rect.top) {
            return;
        }
        const imgScaleX = img.scaleX || 1;
        const imgScaleY = img.scaleY || 1;
        const newOffsetX = (clamped.left - this.left) / imgScaleX;
        const newOffsetY = (clamped.top - this.top) / imgScaleY;
        if (!isFinite(newOffsetX) || !isFinite(newOffsetY)) return;
        this._updateMaskPosition(newOffsetX, newOffsetY);
    },

    // Repositions the image to respect a limit rule (the rule comes from the contain/cover
    //  wrappers below). Returns the corrected position.
    _clampMaskBounds: function (proposedLeft, proposedTop, axisRule) {
        const rect = this._maskBoundsRectangle;
        const corners = this._getRectCornersInPlaceholderLocalSpace(
            rect.width, rect.height, rect.angle, proposedLeft, proposedTop
        );

        const xs = corners.map(p => p.x);
        const ys = corners.map(p => p.y);
        const minX = Math.min.apply(null, xs);
        const maxX = Math.max.apply(null, xs);
        const minY = Math.min.apply(null, ys);
        const maxY = Math.max.apply(null, ys);

        const dxLocal = axisRule(minX, maxX, this.width / 2);
        const dyLocal = axisRule(minY, maxY, this.height / 2);

        if (dxLocal === 0 && dyLocal === 0) {
            return { left: proposedLeft, top: proposedTop };
        }

        // Convert the correction back to canvas coordinates. If the result isn't a valid
        //  number, keep the current position instead of breaking it.
        const m = this.calcTransformMatrix();
        const dxCanvas = m[0] * dxLocal + m[2] * dyLocal;
        const dyCanvas = m[1] * dxLocal + m[3] * dyLocal;
        if (!isFinite(dxCanvas) || !isFinite(dyCanvas)) {
            return { left: proposedLeft, top: proposedTop };
        }
        return { left: proposedLeft + dxCanvas, top: proposedTop + dyCanvas };
    },

    // Limit rule: keep the whole image INSIDE the placeholder (used by "limit movement").
    //  When the image reaches an edge it slides along it instead of jumping to the center.
    _clampMaskBoundsPosition: function (proposedLeft, proposedTop) {
        return this._clampMaskBounds(proposedLeft, proposedTop, function (min, max, half) {
            if (max - min > 2 * half) return -(min + max) / 2;
            if (max > half) return half - max;
            if (min < -half) return -half - min;
            return 0;
        });
    },

    // Limit rule: keep the placeholder fully COVERED by the image, so no blank gaps show on
    //  any side (used by "limit image to placeholder"). Holds up even if the box is rotated.
    _clampMaskBoundsPositionCover: function (proposedLeft, proposedTop) {
        return this._clampMaskBounds(proposedLeft, proposedTop, function (min, max, half) {
            if (max - min < 2 * half) return -(min + max) / 2;
            if (min > -half) return -half - min;
            if (max < half) return half - max;
            return 0;
        });
    },

    _updateMaskPosition: function (offsetX, offsetY) {
        const imgElement = this.item(0);
        if(this.saveImagePosition) {
            let newX = this.left + (offsetX  * imgElement.scaleX);
            let newY = this.top + (offsetY * imgElement.scaleY);
            const constrainedPoint = constrainPositionToBoundingBox(this, this._maskBoundsRectangle, newX, newY);
            offsetX = (constrainedPoint.x - this.left) / imgElement.scaleX;
            offsetY = (constrainedPoint.y - this.top) / imgElement.scaleY;
        }
        const result = this._correctOffset(offsetX, offsetY);

        this._maskBoundsRectangle._lastDistanceX = offsetX;
        this._maskBoundsRectangle._lastDistanceY = offsetY;

        if (!this.hasMask) {
            imgElement.set('left', result.x * imgElement.scaleX);
            imgElement.set('top', result.y * imgElement.scaleY);

            this._maskBoundsRectangle.set('left', this.left + offsetX * imgElement.scaleX);
            this._maskBoundsRectangle.set('top', this.top + offsetY * imgElement.scaleX);
        } else {
            imgElement.set('maskOffsetX', result.x);
            imgElement.set('maskOffsetY', result.y);

            this._maskBoundsRectangle.set('left', this.left + offsetX * imgElement.scaleX);
            this._maskBoundsRectangle.set('top', this.top + offsetY * imgElement.scaleY);
        }

        this._maskBoundsRectangle.setCoords();
    },

    _updateMaskAngle: function (angle) {
        if (this.saveImagePosition) {
            this._maskBoundsRectangle.set('angle', angle + this.angle);
            var constrainRotation = constrainRotationToBoundingBox(this, this._maskBoundsRectangle);
            if (constrainRotation.minRotationDelta == 0 || constrainRotation.maxRotationDelta == 0) {
                this._maskBoundsRectangle.angle = this.lastAngle;
            }
            this.lastAngle = this._maskBoundsRectangle.angle;
            angle = this._maskBoundsRectangle.angle - this.angle;
        }
        if (!this.hasMask) {
            this.item(0).set('angle', angle);
        } else {
            this.item(0).set('maskAngle', angle);
        }
        this._maskBoundsRectangle.set('angle', angle + this.angle);
        this._maskBoundsRectangle.setCoords();
    },

    _updateMaskScale: function (scaleX, scaleY) {
        // Scale the image
        if (!this.hasMask) {
            this._noMaskScaleX = scaleX;
            this._noMaskScaleY = scaleY;
            this._adjustImage();
        } else {
            this.item(0).set('maskScaleX', scaleX);
            this.item(0).set('maskScaleY', scaleY);
            if (this.originalMaskSvg) {
                this.item(0).set('scaleX', this._noMaskOriginalImgScale * scaleX);
                this.item(0).set('scaleY', this._noMaskOriginalImgScale * scaleY);
                this._updateSvgClipPath();
            }
        }

        const initialBoundsSize = this._getInitialBoundsRectangleSize();
        this._maskBoundsRectangle.set('width', initialBoundsSize.width * scaleX);
        this._maskBoundsRectangle.set('height', initialBoundsSize.height * scaleY);
        if (!this.hasMask) {
            const inverse = this._inverseCorrectOffset(
                this.item(0).left / this.item(0).scaleX,
                this.item(0).top / this.item(0).scaleY
            );
            this._updateMaskPosition(inverse.x, inverse.y);
        }
        this._maskBoundsRectangle.setCoords();
    },

    setMode: function (mode) {
        const imageObj = this.item(0);
        //if there are any color filters applied, we need to remove them as Customily's color mode is desinged to be exclusive
        //in other words, to when applying a Customily color mode, we must make sure that there aren't other color mode filters applied at the same time
        if (
            this.item(0).filters[0] instanceof fabric.Image.filters.KMeans ||
            this.item(0).filters[0] instanceof fabric.Image.filters.Grayscale
        ) {
            imageObj.filters.shift();
        }
        if (mode === fabric.IMAGE_MODE_SINGLE_COLOR) {
            this.imageMode = mode;

            const kMeansFilter = new fabric.Image.filters.KMeans({
                threshold: this.threshold,
                fgColor: this.imageColor,
                bgColor: 'rgba(0,0,0,0)'
            });

            //always apply color mode filters at the begining of the array (using unshift)
            //so they won't affect the filters that are applied on later array indexes.
            //this prevents for example, the single color filter to affect the outline
            imageObj.filters.unshift(kMeansFilter);
        } else if (mode === fabric.IMAGE_MODE_FULL_COLOR) {
            this.imageMode = mode;
        } else if (mode === fabric.IMAGE_MODE_GRADING) {
            this.imageMode = mode;
            imageObj.filters.unshift(new fabric.Image.filters.Grayscale());
        }

        imageObj.set('dirty', true);
        this.set('dirty', true);
        imageObj.applyFilters();
    },

    _computeImageScaling: function (useInitValues = false) {
        let scale = 1;
        const width = useInitValues && this.hasInitValues() ? this.initWidth : this.getWidth();
        const height = useInitValues && this.hasInitValues() ? this.initHeight : this.getHeight();
        const boundsWidth = useInitValues && this.hasInitValues() ? this.initWidth : this.item(1).width;
        const boundsHeight = useInitValues && this.hasInitValues() ? this.initHeight : this.item(1).height;
        if (this.originalElement && this.originalElement.width != 0 && this.originalElement.height != 0) {
            // Make the image object fit the group bounds without altering the aspect ratio
            if (this.originalElement.width > this.originalElement.height) {
                scale = width / this.originalElement.width;

                // If the images goes over the bounds height, scale by height instead
                if (this.originalElement.height * scale > boundsHeight) {
                    scale = height / this.originalElement.height;
                }
            } else if (this.originalElement.height > this.originalElement.width) {
                scale = height / this.originalElement.height;

                // If the images goes over the bounds width, scale by width instead
                if (this.originalElement.width * scale > boundsWidth) {
                    scale = width / this.originalElement.width;
                }
            } else {
                // Same width and height
                scale = Math.min(
                    width / this.originalElement.width,
                    height / this.originalElement.height
                );
            }
        }

        return scale;
    },

    _adjustImage: function (ignoreMaskScale) {
        // Scale only if valid image
        if (this.originalElement && this.originalElement.width != 0 && this.originalElement.height != 0) {
            const scale = this._computeImageScaling();
            this._noMaskOriginalImgScale = scale;

            // Apply scale factor to the image when no image mask is being used, this is because the scaling is done
            //  by simply scaling the fabric image object
            let scaleX = scale;
            let scaleY = scale;
            if (!ignoreMaskScale) {
                scaleX = scale * this._noMaskScaleX;
                scaleY = scale * this._noMaskScaleY;
            }

            this.item(0).set('scaleX', scaleX);
            this.item(0).set('scaleY', scaleY);
            this.item(0).setCoords();
            this._updateSvgClipPath();
        }
    },

    _adjustClippingPath: function () {
        if (this.enableClipPath) {
            if (!this.clipPath) {
                this.set(
                    'clipPath',
                    new fabric.Rect({
                        originX: 'center',
                        originY: 'center'
                    })
                );
            }
            if (this.clipPath.set) {
                this.clipPath.set('width', this.width);
                this.clipPath.set('height', this.height);
            }
        } else {
            this.set('clipPath', null);
        }
    },

    setCoords: function (skipCorners) {
        this.callSuper('setCoords', skipCorners);
        this._updateSvgClipPath();
    },

    // Fabric's dirty clear only covers cacheWidth x cacheHeight; a clip overshooting it would otherwise leave stale pixels in the cache's growth margin
    isCacheDirty: function (skipCanvas) {
        const dirty = this.callSuper('isCacheDirty', skipCanvas);
        if (dirty && !skipCanvas && this._cacheCanvas && this._cacheContext) {
            const ctx = this._cacheContext;
            ctx.save();
            ctx.setTransform(1, 0, 0, 1, 0, 0);
            ctx.clearRect(0, 0, this._cacheCanvas.width, this._cacheCanvas.height);
            ctx.restore();
        }
        return dirty;
    },

    _updateSvgClipPath: function () {
        const innerImage = this.item(0);
        if (!this.hasMask || !this.originalMaskSvg || !innerImage || !innerImage.clipPath) {
            return;
        }
        const clipPath = innerImage.clipPath;
        if (!(clipPath.width > 0) || !(clipPath.height > 0)) {
             return;
         }
        const center = this.getCenterPoint();
        const width = this.getWidth();
        const height = this.getHeight();
        clipPath.left = center.x;
        clipPath.top = center.y;
        clipPath.angle = this.angle || 0;
        clipPath.scaleX = width / clipPath.width;
        clipPath.scaleY = height / clipPath.height;
        clipPath.setCoords();
    },

    // Overridden method from group
    _drawControl: function (control, ctx, methodName, left, top, styleOverride) {
        // Do not draw controls when in edit mode
        if (this._editMode) {
            return;
        }
        this.callSuper('_drawControl', control, ctx, methodName, left, top, styleOverride);
    },

    // Overridden method from group
    drawBorders: function (ctx, styleOverride) {
        // Do not draw bounding box when in edit mode
        if (this._editMode) {
            return;
        }
        this.callSuper('drawBorders', ctx, styleOverride);
    },

    toObject: function (propertiesToInclude) {
        const additionalProperties = [
            'id',
            'uuid',
            'strokeWidth',
            'strokeDashArray',
            'stroke',
            'centeredRotation',
            'skewX',
            'skewY',
            'lockSkewingX',
            'lockSkewingY',
            'lockScalingFlip',
            'coverMaskArea',
            'fullColor',
            'grading',
            'zIndex',
            'color',
            'hasStaticImage',
            'dynamicImagesPath',
            'dynamicImageVariation',
            'selectedColorPosition',
            'imageColor',
            'imageLibraryId',
            'isPrintArea',
            'colorLibraryId',
            'colors',
            'selectedColorPosition',
            'rotationStep',
            'removeWhiteBackground',
            'preventEditMode',
            'evented',
            'selectable',
            'visible',
            'locked',
            'name',
            'maskPath',
            'maskChanged',
            'imageMode',
            'RemoveBackground',
            'groupId',
            'pageEpsId',
            'mapConfig',
            'wordCloudConfig',
            'wordSearchConfig',
            'isMoonPhase',
            'CutoutFace',
            'removeBackgroundCOP',
            'CustomilyRemoveBackground',
            'CustomilyFaceCutOut',
            'CustomilyImageFilter',
            'isLimitImageToPlaceholder',
            'lockMovement',
            'lockScaling',
            'textToImage',
            'imageToImage',
            'imageToImageConfig',
            'imageEffects',
            'isGuide',
            'allowEdit',
            'crossword',
            'CrosswordConfig',
            'crosswordSettings',
            'calendar',
            'calendarConfig',
            'enablePerspective',
            'perspectiveCoords',
            'isProductGuidelines',
            'pageEpsId',
            'initCenterX',
            'initCenterY',
            'initWidth',
            'initHeight',
            'initRotation',
            'outlineColor',
            'outlineWidth',
            'shadowType',
            'shadowOffset',
            'shadowAngle',
            'shadowBlur',
            'shadowColor',
            // The resolved css, not just the saved color option: without it a copied element would
            //  repaint its shadow with the default fill until the color option is resolved again.
            'shadowFill',
            'shadowColorOption',
            'shadowColorLibraryId',
            'allowSwapLibraryPosition',
            'limitMovement'
        ].concat(propertiesToInclude);

        const maskImageSrc = this.originalMaskElement ? this.originalMaskElement.src : this.maskImageSrc;
        const imageSrc = this.originalElement ? this.originalElement.src : undefined;
        return fabric.util.object.extend(this.callSuper('toObject', additionalProperties), {
            maskImageSrc: maskImageSrc,
            imageSrc: imageSrc,
            // As entries, not as a Map: this has to survive JSON both when copying an element on
            //  the canvas and when going to the database.
            shadowColorsMap: Array.from(this.shadowColorsMap || [])
        });
    }
});

fabric.ImagePlaceholder.fromObject = function (object, callback) {
    const maskImageSrc = object.maskImageSrc;
    const imageSrc = object.imageSrc;
    object.maskImageSrc = undefined;
    object.clipPath = undefined;

    const loadMask = function () {
        return new Promise((resolve) => {
            // Load and set the mask image
            if (newObject.maskPath || maskImageSrc) {
                const maskImage = new Image();
                maskImage.onload = function () {
                    newObject.setMask(maskImage);
                    resolve();
                };
                maskImage.onerror = function () {
                    resolve();
                };
                maskImage.crossOrigin = 'Anonymous';
                maskImage.src = maskImageSrc;
            } else {
                resolve();
            }
        });
    };

    const loadImage = function () {
        return new Promise((resolve) => {
            // Load and set the mask image
            if (imageSrc) {
                const image = new Image();
                image.onload = function () {
                    newObject.setElement(image);
                    resolve();
                };
                image.onerror = function () {
                    resolve();
                };
                image.crossOrigin = 'Anonymous';
                image.src = imageSrc;
            } else {
                resolve();
            }
        });
    };

    newObject = new fabric.ImagePlaceholder(null, object);

    loadMask()
        .then(() => {
            return loadImage();
        })
        .then(() => {
            callback(newObject);
        });
};
